import { useEffect, useRef } from 'react'
import { useEvent } from '@fs/zion-frontend-friends'

export default function useOnClose({ isOpen, transitioning, onClose }) {
  const handleOnClose = useEvent(onClose)
  const wasOpenedRef = useRef(false)

  useEffect(() => {
    if (isOpen) wasOpenedRef.current = true
    else if (!transitioning && wasOpenedRef.current) {
      handleOnClose()
      wasOpenedRef.current = false
    }
  }, [isOpen, transitioning, handleOnClose])

  useEffect(
    () => () => {
      if (wasOpenedRef.current) handleOnClose()
    },
    [handleOnClose]
  )
}
